import React from "react";
import styled from "styled-components";
import { Text, theme } from "@ifgengineering/component-library";
import { Right } from "@icon-park/react";
import pieChartIcon from "@assets/images/piechart.png";

const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 496px;
  max-width: 100%;
  padding: 16px 20px;
  background: ${theme.colors.WHITE};
  border: 1px solid ${theme.colors.SLATE200};
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${theme.colors.SLATE100};
  }

  &:active {
    background: ${theme.colors.SLATE100};
  }
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PieChartImage = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

interface EisFundEntryPointProps {
  numOfCompaniesDeployedInto?: number | null;
  onClick: () => void;
}

const EisFundEntryPoint: React.FC<EisFundEntryPointProps> = ({
  numOfCompaniesDeployedInto,
  onClick,
}) => {
  if (!numOfCompaniesDeployedInto) return null;

  return (
    <Container onClick={onClick}>
      <LeftContent>
        <PieChartImage src={pieChartIcon} alt="Pie chart" />
        <Text type="S16" color="SLATE800">
          EIS Fund Startups ({numOfCompaniesDeployedInto})
        </Text>
      </LeftContent>
      <Right size={20} theme="outline" fill={theme.colors.SLATE500} />
    </Container>
  );
};

export default EisFundEntryPoint;
